import { Text } from "@certn/cascadia";
import { ArrayLayoutProps } from "@jsonforms/core";
import { useContext, useEffect, useState } from "react";
import { CascadiaJsonFormContext } from "../../../../CascadiaJsonFormContext";
import get from "lodash.get";
import { hasHeading } from "./utils";

export function ItemsHeading(props: ArrayLayoutProps) {
  const { label, path } = props;
  const { values } = useContext(CascadiaJsonFormContext);
  const [itemsCount, setItemsCount] = useState("0");

  useEffect(() => {
    const items = get(values, path, []);
    if (Array.isArray(items)) {
      setItemsCount(items.length.toString());
    }
  }, [values, path]);

  if (hasHeading(props)) {
    return (
      <Text style="global/heading-large">
        {label} ({itemsCount})
      </Text>
    );
  }
}
